import {observer} from "mobx-react";
import {useEffect, useState} from "react";

import {authStore, DialogStore, kpiCustomerStore, kpiWeighingDialogListStore} from "../../../store";
import {WeighingDialog} from "./WeighingDialog";
import {WeighingChart} from "./WeighingChart";
import {useSearchParams} from "react-router";
import {kpiWeighingCreateStore} from "../../../store/kpi/KpiWeighingCreateStore";

const Weighings = observer(function Weighings() {
    const [tab, setTab] = useState<'chart' | 'table'>('chart')
    const [weighingDialogStore] = useState(new DialogStore())
    const [hasRoleKpiWrite, setHasRoleKpiWrite] = useState(false)
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const has = authStore.hasRole('KPI_WRITE_AMOUNT')
        setHasRoleKpiWrite(has)
        // hasRole
    }, [])

    return <>
        <WeighingDialog store={weighingDialogStore}/>

        <div className="card">
            <header className="card-header">
                <p className="card-header-title">Posterfassung</p>
                <div style={{
                    display: 'flex',
                    paddingRight: '0.5em',
                    alignItems: 'center'
                }}>
                    {hasRoleKpiWrite && <button
                        className={'button is-small is-rounded is-primary'}
                        onClick={() => {
                            const customerId = searchParams.get('customerId') || undefined
                            kpiWeighingCreateStore.reset(false)
                            const customer = kpiCustomerStore.getCustomerById(customerId)
                            if (customer) {
                                kpiWeighingCreateStore.customer = kpiCustomerStore.getCustomerById(customerId)
                                kpiWeighingDialogListStore.customerId = customerId
                            }
                            kpiWeighingDialogListStore.load().finally()
                            weighingDialogStore.dialogOpen = true
                        }}
                    >
                        Hinzufügen
                    </button>}
                </div>
            </header>
            <div className="tabs is-boxed is-small" style={{marginBottom: '0'}}>
                <ul>
                    <li className={'is-active'}>
                        <a href={'#chart'} onClick={e => {
                            e.preventDefault()
                            setTab('chart')
                        }}>
                            <span className="material-symbols-outlined">line_axis</span>
                            <span>Total</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div style={{height: '20em', display: 'flex'}}>
                {tab === 'chart' && <WeighingChart />}
            </div>
        </div>
    </>
})

export {
    Weighings
}
